// extracted by mini-css-extract-plugin
module.exports = {"calls__th_id":"calls__th_id","calls__th_date":"calls__th_date","calls__th_duration":"calls__th_duration","calls__th_phone":"calls__th_phone","calls__th_client":"calls__th_client"};